import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { BodyText, ButtonText } from '@panel/commons/lib/typography';
import { getNeutralColors } from '@panel/commons/lib/theme';
import { Icon } from '@panel/commons/lib/Icon/Icon';

const fadeIn = keyframes`
  from {
    opacity: 0;
    bottom: -100%;
  }
  to {
    opacity: 1;
    bottom: 0%;
  }
`;

const ModalWrapper = styled.div`
  background-color: ${getNeutralColors('white')};
  border-radius: 8px 8px 0px 0px;
  position: fixed;
  bottom: 0px;
  width: 100%;

  animation: ${fadeIn} 0.5s ease-out forwards;
  ${({ noAnimation }) =>
    noAnimation &&
    css`
      animation: none;
    `}
  opacity: 1;

  :after {
    content: '';
    height: 4px;
    width: 50px;
    position: absolute;
    background: ${getNeutralColors('grisMedioOscuro')};
    border-radius: 4px;
    top: 8px;
    left: calc(50% - 25px);
  }
`;

const ModalHeader = styled.div`
  padding: 16px;
`;

const CloseButton = styled(ButtonText).attrs({
  type: 'button',
  as: 'button'
})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  width: 38px;
  margin-left: 16px;
  position: absolute;
  top: 10px;
  right: 8px;
  :hover {
    cursor: pointer;
  }
`;

const ModalContainer = styled.div`
  display: block;
  padding: ${({ noHeader }) => (noHeader ? '0' : '16px')};
`;

function Mobile({ title, onClose, children, withoutCloseButton = false, noHeader = false, noAnimation = false }) {
  return (
    <ModalWrapper noAnimation={noAnimation}>
      {!noHeader && (
        <ModalHeader>
          {title && <BodyText size={100}>{title}</BodyText>}
          {!withoutCloseButton && (
            <CloseButton onClick={onClose}>
              <Icon name='close' size={200} />
            </CloseButton>
          )}
        </ModalHeader>
      )}
      <ModalContainer noHeader={noHeader}>{children}</ModalContainer>
    </ModalWrapper>
  );
}

export default Mobile;
